import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { BreadcrumbsService } from './core/services/breadcrumbs.service'
import { GeneralMapRandomParamService } from './domain/general-map/components/general-map/services/general-map-random-param.service'
import { MainViewActionsService } from './core/layout/state/main-view-actions.service'
import { GoogleAnalyticsService } from './core/monitoring/google-analytics.service'
import { NavigationCommandsService } from './features/command-palette/services/navigation-commands.service'

@Component({
    selector: 'ca-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy  {

    constructor(@Inject(BreadcrumbsService) private breadcrumbsService: BreadcrumbsService,
                @Inject(GeneralMapRandomParamService) private mapRandomParamService: GeneralMapRandomParamService,
                @Inject(MainViewActionsService) private mainViewActionsService: MainViewActionsService,
                @Inject(Router) private router: Router,
                @Inject(GoogleAnalyticsService) private googleAnalyticsService: GoogleAnalyticsService,
                @Inject(NavigationCommandsService) private navigationCommandsService: NavigationCommandsService) {
    }

    ngOnInit(): void {
        this.mapRandomParamService.setMapRandom(true)
        this.updateGlobalState()
        this.googleAnalyticsService.initialize()
        this.navigationCommandsService.registerAll()
        window.addEventListener('beforeprint', this.logPrintDialogEvent)

        // NOTE: Exit control (unsaved changes dialog) is now handled by UnsavedChangesGuard
        // applied to edit routes in their respective routing modules
    }

    ngOnDestroy(): void {
        window.removeEventListener('beforeprint', this.logPrintDialogEvent)
    }

    /**
     * Updates contract/subcontract state default values from project.
     * @private
     */
    private updateGlobalState(): void {
        this.mainViewActionsService.setAllIsEditingFalse()
    }

    private logPrintDialogEvent = (): void => {
        // Use Angular Router's current URL for logging
        const currentUrl = this.router.url
        this.googleAnalyticsService.logEvent('browser', 'print_dialog', currentUrl)
    }
}
